module.exports = __webpack_public_path__ + "static/media/Logo.618ad364.svg";